import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  wrapper: {
    marginTop: 42
  },
  title: {
    marginBottom: 12,
    marginTop: 42
  },
  inputIndent: {
    marginTop: 30
  },
  button: {
    width: '100%',
    marginTop: 30,
    marginBottom: theme.spacing(3)
  },
  sentEmailWrapper: {
    marginTop: 145
  },
  backLogin: {
    marginTop: '24px'
  }
}));

export default useStyles;
